import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, mergeMap } from 'rxjs/operators';
import { EMPTY, from, of } from 'rxjs';
import { inject } from '@angular/core';
import { GetLocaleStore } from '../../../../dictionary/store/get-locale.store';
import { SfAuthActions } from './sf-auth.store';

export const requestDictionary$ = createEffect(
  () => {
    const actions$ = inject(Actions);
    const getLocaleStore = inject(GetLocaleStore);
    return actions$.pipe(
      ofType(SfAuthActions.dictionaryRequested),
      exhaustMap(({ localeId }) =>
        from(getLocaleStore.loadDictionaryForRegisterAndLogin(localeId)).pipe(
          mergeMap(() => EMPTY),
          catchError(() =>
            of(
              SfAuthActions.generalErrorModeUpdated({
                generalErrorMode: 'dictionary',
              })
            )
          )
        )
      )
    );
  },
  { functional: true }
);
